/**
 * 매칭 단계(lvl) 별 인원수 가로 막대 그래프 ($j.Ui.JBModal.target 결합).
 *
 * 사용법:
 *   $j.Ui.JBModal.target('match-level-chart-modal', {
 *       target: '$j.F.Admin.Order.MatchLevelChart',
 *       data:   { stats: [...], levelAll: [...], matchType: 'NC' },
 *       title:  '단계별 인원수',
 *       width:  '720px',
 *   });
 *
 * stats    — 실 매칭된 lvl 만  ({lvl, count, memo})
 * levelAll — g5_match_level dt=$matchType 전체 lvl ({lvl, memo}) — 전체보기 체크 시 사용
 *
 * Chart.js 없이 순수 HTML/CSS 막대 그래프.
 */
export default class MatchLevelChart {
    constructor() {}
    destroy() {}

    init() {
        this.stats     = this.data.stats    || [];
        this.levelAll  = this.data.levelAll || [];
        this.matchType = this.data.matchType || '';
        this.ver       = (this.data.ver !== undefined && this.data.ver !== null && this.data.ver !== '') ? String(this.data.ver) : '';
        this.showAll   = false;
        this.render();
        this.bind();
    }

    rows() {
        // 기본 화면: 실제 매칭된 모든 단계 (인원수 있는 단계 전부).
        if (!this.showAll) {
            return this.stats.slice();
        }

        // 전체보기: g5_match_level dt=matchType 전체 단계 (count=0 단계도 포함).
        const statsMap = {};
        this.stats.forEach(r => { statsMap[r.lvl] = r; });
        return this.levelAll.map(r => {
            const lvl = parseInt(r.lvl);
            const s = statsMap[lvl];
            return {
                lvl,
                count: s ? (s.count | 0) : 0,
                memo:  String(r.memo || ''),
                ptMax: s ? s.ptMax : null,
                ptMin: s ? s.ptMin : null,
            };
        });
    }

    render() {
        const rows = this.rows();
        const hasAny = this.stats.length > 0;

        if (!hasAny && !this.showAll) {
            $(`#${this.id}`).html(this._wrap('<div style="padding:24px;text-align:center;color:#888">매칭 데이터가 없습니다.</div>'));
            return;
        }

        const total = this.stats.reduce((s, r) => s + (r.count | 0), 0);
        const max   = Math.max(1, ...rows.map(r => r.count | 0));
        const fmtPt = (v) => v == null ? '' : Number(v).toLocaleString();

        const trs = rows.map(r => {
            const count = r.count | 0;
            const pct   = count > 0 ? (count / max * 100) : 0;
            const share = total > 0 ? (count / total * 100) : 0;
            const memo  = this._esc(r.memo || '');
            const dim   = count === 0 ? ' mlc-dim' : '';
            const ptInline = r.ptMax != null
                ? ` <span class="mlc-pt-inline">(최고 ${fmtPt(r.ptMax)})</span>`
                : '';
            return `
                <tr class="${dim.trim()}">
                    <td class="mlc-lvl">${r.lvl}</td>
                    <td class="mlc-memo">${memo || '<span class="mlc-muted">—</span>'}${ptInline}</td>
                    <td class="mlc-bar-cell">
                        <div class="mlc-bar-wrap">
                            ${count > 0 ? `<div class="mlc-bar" style="width:${pct.toFixed(2)}%"></div>` : ''}
                        </div>
                    </td>
                    <td class="mlc-count">${count.toLocaleString()}</td>
                    <td class="mlc-share">${count > 0 ? share.toFixed(1) + '%' : '—'}</td>
                </tr>`;
        }).join('');

        const body = `
            <table class="mlc-tbl">
                <colgroup>
                    <col style="width:48px"><col><col style="width:30%"><col style="width:60px"><col style="width:56px">
                </colgroup>
                <thead>
                    <tr>
                        <th>단계</th>
                        <th>설명</th>
                        <th>분포</th>
                        <th>인원</th>
                        <th>비율</th>
                    </tr>
                </thead>
                <tbody>${trs}</tbody>
            </table>`;

        $(`#${this.id}`).html(this._wrap(body, total));
    }

    _wrap(body, total = 0) {
        const checked = this.showAll ? 'checked' : '';
        const allCount = this.levelAll.length;
        const hasAll = allCount > 0;
        const hint = hasAll ? `<span class="mlc-muted" style="margin-left:6px">(${allCount}개 단계)</span>` : '';
        return `
            <style>
                #${this.id} .mlc-head { display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;font-size:13px;flex-wrap:wrap;gap:8px; }
                #${this.id} .mlc-head .mlc-type { font-weight:700;color:#1D4ED8; }
                #${this.id} .mlc-head .mlc-ver { font-size:11px;font-weight:700;color:#fff;background:#6B7280;border-radius:4px;padding:1px 6px;margin-left:4px;vertical-align:middle; }
                #${this.id} .mlc-head .mlc-total { color:#374151; }
                #${this.id} .mlc-chk { display:inline-flex;align-items:center;gap:6px;cursor:pointer;font-size:12px;color:#374151;user-select:none; }
                #${this.id} .mlc-chk input { cursor:pointer; }
                #${this.id} table.mlc-tbl { width:100%;border-collapse:collapse;font-size:12px;table-layout:fixed; }
                #${this.id} table.mlc-tbl th { background:#f3f4f6;color:#374151;font-weight:700;padding:6px 8px;border:1px solid #e5e7eb;text-align:center; }
                #${this.id} table.mlc-tbl td { padding:6px 8px;border:1px solid #e5e7eb;vertical-align:middle; }
                #${this.id} tr.mlc-dim td { background:#fafafa;color:#9CA3AF; }
                #${this.id} td.mlc-lvl { text-align:center;font-weight:700;color:#1D4ED8;width:48px; }
                #${this.id} tr.mlc-dim td.mlc-lvl { color:#9CA3AF; }
                #${this.id} td.mlc-memo { font-size:11.5px;color:#374151;white-space:normal;word-break:keep-all;line-height:1.45; }
                #${this.id} td.mlc-bar-cell { width:30%;padding:6px 10px; }
                #${this.id} td.mlc-count { text-align:right;font-weight:700;width:60px; }
                #${this.id} td.mlc-share { text-align:right;color:#6B7280;width:56px; }
                #${this.id} .mlc-pt-inline { color:#15803D;font-weight:600;font-size:11px;margin-left:2px; }
                #${this.id} .mlc-muted { color:#9CA3AF; }
                #${this.id} .mlc-bar-wrap { background:#F3F4F6;border-radius:6px;height:18px;overflow:hidden; }
                #${this.id} .mlc-bar { height:100%;background:linear-gradient(90deg,#60A5FA,#1D4ED8);border-radius:6px;transition:width .3s ease; }
            </style>
            <div class="mlc-head">
                <span>매칭타입 <span class="mlc-type">${this._esc(this.matchType || '—')}</span>${this.ver ? ` <span class="mlc-ver">ver ${this._esc(this.ver)}</span>` : ''}</span>
                <label class="mlc-chk">
                    <input type="checkbox" id="mlc-show-all" ${checked} ${hasAll ? '' : 'disabled'}>
                    전체보기 ${hint}
                </label>
                <span class="mlc-total">총 매칭 <b>${(total || 0).toLocaleString()}</b>명 · ${this.stats.length}개 단계</span>
            </div>
            ${body}
        `;
    }

    bind() {
        const self = this;
        $(`#${this.id}`).off('change.mlc').on('change.mlc', '#mlc-show-all', function () {
            self.showAll = this.checked;
            self.render();
        });
    }

    _esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }
}
